// Cookie banner: Accept all / Reject all / Customise, with equal weight on
// accept and reject. Mounted once in App.js's Layout; the footer's "Cookie
// Settings" link reopens it through openCookieSettings().
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { OPEN_EVENT, readConsent, saveConsent } from "../utils/cookieConsent";
import "./CookieConsent.css";

export default function CookieConsent() {
  const [open, setOpen] = useState(false);
  const [customising, setCustomising] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    if (!readConsent()) setOpen(true);
    const reopen = () => {
      const c = readConsent();
      setAnalytics(!!(c && c.analytics));
      setMarketing(!!(c && c.marketing));
      setCustomising(true);
      setOpen(true);
    };
    window.addEventListener(OPEN_EVENT, reopen);
    return () => window.removeEventListener(OPEN_EVENT, reopen);
  }, []);

  if (!open) return null;

  const choose = (a, m) => {
    saveConsent(a, m);
    setOpen(false);
    setCustomising(false);
  };

  return (
    <div className="cc-banner" role="dialog" aria-label="Cookie preferences" aria-live="polite">
      <div className="cc-inner">
        <div className="cc-text">
          <strong>We value your privacy</strong>
          <p>
            We use cookies to understand how visitors use our site and to measure our advertising. Essential
            cookies are always on; the rest only run if you agree. See our{" "}
            <Link to="/about/cookie-policy">Cookie Policy</Link>.
          </p>

          {customising && (
            <div className="cc-options">
              <label className="cc-option">
                <input type="checkbox" checked disabled />
                <span>
                  <b>Essential</b> Needed for the site to work (cart, sign-in, forms). Always on.
                </span>
              </label>
              <label className="cc-option">
                <input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} />
                <span>
                  <b>Analytics</b> Google Analytics: which pages are visited, so we can improve the site.
                </span>
              </label>
              <label className="cc-option">
                <input type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} />
                <span>
                  <b>Advertising</b> Google Ads: measures whether our ads lead to enquiries.
                </span>
              </label>
            </div>
          )}
        </div>

        <div className="cc-actions">
          <button type="button" className="cc-btn" onClick={() => choose(false, false)}>
            Reject all
          </button>
          {customising ? (
            <button type="button" className="cc-btn" onClick={() => choose(analytics, marketing)}>
              Save choices
            </button>
          ) : (
            <button type="button" className="cc-btn cc-btn-ghost" onClick={() => setCustomising(true)}>
              Customise
            </button>
          )}
          <button type="button" className="cc-btn" onClick={() => choose(true, true)}>
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
}
